/**
 * Topics用Swiper初期化モジュール
 *
 * `.m-topics__contents` 配下のSwiperを初期化します。
 * HTMLは変更しない前提のため、セレクタは構造ベースでスコープします。
 */

/**
 * Topics用スライダーの初期化
 */
export function initTopicsSwiper() {
  // Swiperが読み込まれているか確認
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  const topicsContentsList = document.querySelectorAll('.m-topics__contents');
  if (!topicsContentsList.length) return;

  topicsContentsList.forEach((topicsContents) => {
    const swiperEl = topicsContents.querySelector('.js-swiper-topics');
    if (!swiperEl) return;

    const prevEl = topicsContents.querySelector('.js-topics-prev');
    const nextEl = topicsContents.querySelector('.js-topics-next');

    // 既に初期化済みなら何もしない
    if (swiperEl.dataset.swiperInitialized === 'true') return;
    swiperEl.dataset.swiperInitialized = 'true';

    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 40,
      speed: 800,
      grabCursor: true,
      navigation: {
        nextEl,
        prevEl,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: '前へ',
        nextSlideMessage: '次へ',
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 160,
        },
      },
    });
  });
}
